// extracted by mini-css-extract-plugin
export default {"column":"Quota_column__yL84z","quota-details":"Quota_quota-details__YnaRv","percentage":"Quota_percentage__l22vu","usage":"Quota_usage__QM8Ld","quota-info":"Quota_quota-info__xm1ZE"};